import type { RouteObject } from 'react-router-dom';

import { libraryRoutes } from './ctlConfig/libraryRoutes';
import { plantEquipmentRoutes } from './ctlConfig/plantEquipmentRoutes';

const ctlConfigRoutes: RouteObject[] = [...libraryRoutes, ...plantEquipmentRoutes];

export default ctlConfigRoutes;
